'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _joiBrowser = require('joi-browser');

var _joiBrowser2 = _interopRequireDefault(_joiBrowser);

var _lodash = require('lodash');

var _FieldLayout = require('./form/FieldLayout');

var _FieldLayout2 = _interopRequireDefault(_FieldLayout);

var _EthereumAddressInput = require('./form/elements/EthereumAddressInput');

var _EthereumAddressInput2 = _interopRequireDefault(_EthereumAddressInput);

var _joiExtensions = require('../utilities/joiExtensions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExternalWalletOptions = function (_React$Component) {
  _inherits(ExternalWalletOptions, _React$Component);

  function ExternalWalletOptions(props) {
    _classCallCheck(this, ExternalWalletOptions);

    var _this = _possibleConstructorReturn(this, (ExternalWalletOptions.__proto__ || Object.getPrototypeOf(ExternalWalletOptions)).call(this, props));

    _this.state = {
      errors: {},
      input: { address: '' }
    };

    _this.handleChange = _this.handleChange.bind(_this);
    _this.validateForm = _this.validateForm.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }

  _createClass(ExternalWalletOptions, [{
    key: 'handleChange',
    value: function handleChange(id, value) {
      var input = _extends({}, this.state.input, _defineProperty({}, id, value));
      this.setState({ input: input });
    }
  }, {
    key: 'validateForm',
    value: function validateForm() {
      var customJoi = _joiBrowser2.default.extend((0, _joiExtensions.ethereumAddress)(_joiBrowser2.default));
      var schema = {
        address: customJoi.ethereumAddress().label('Address').empty('').required()
      };

      var _Joi$validate = _joiBrowser2.default.validate(this.state.input, schema, {
        abortEarly: false
      }),
          error = _Joi$validate.error;

      return error && error.details ? error.details.reduce(function (errors, _ref) {
        var path = _ref.path,
            message = _ref.message;
        return _extends({}, errors, _defineProperty({}, (0, _lodash.last)(path), message));
      }, {}) : {};
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(event) {
      event.preventDefault();
      var errors = this.validateForm();
      this.setState({ errors: errors });
      if ((0, _lodash.isEmpty)(errors)) {
        this.props.onSubmit({ address: this.state.input.address });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'external-wallet-options' },
        _react2.default.createElement(
          'h2',
          null,
          'Enter Your Wallet Address'
        ),
        _react2.default.createElement(
          'form',
          { onSubmit: this.handleSubmit, className: 'form' },
          _react2.default.createElement(
            'div',
            { className: 'form-row' },
            _react2.default.createElement(
              _FieldLayout2.default,
              {
                id: 'address',
                label: 'Address',
                inputId: 'address',
                className: 'input-field input-with-icon',
                errorText: this.state.errors.address,
                type: 'ethereum-address-input',
                required: true
              },
              _react2.default.createElement(_EthereumAddressInput2.default, {
                id: 'address',
                value: this.state.input.address,
                onChange: this.handleChange,
                onBlur: _lodash.noop,
                inputOptions: { autoFocus: true }
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'actions' },
            _react2.default.createElement(
              'button',
              {
                type: 'button',
                name: 'back',
                className: 'btn cancel',
                onClick: function onClick() {
                  return _this2.props.onSubmit({});
                }
              },
              'Back'
            ),
            _react2.default.createElement(
              'button',
              { type: 'submit', name: 'continue', className: 'btn' },
              'Submit'
            )
          )
        )
      );
    }
  }]);

  return ExternalWalletOptions;
}(_react2.default.Component);

ExternalWalletOptions.displayName = 'ExternalWalletOptions';

ExternalWalletOptions.defaultProps = {
  onSubmit: function onSubmit() {
    return null;
  }
};

ExternalWalletOptions.propTypes = {
  onSubmit: _propTypes2.default.func
};

exports.default = ExternalWalletOptions;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/components/ExternalWalletOptions.js
// module id = 1079
// module chunks = 0